import { useState } from "react";
import CreateSaleUI from "../components/CreateSaleUI";
import { getUser } from "../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function CreateSale({ open, onClose, allProducts, productTypes, empresa }) {
  const [selectedProducts, setSelectedProducts] = useState({});
  const [selectedType, setSelectedType] = useState(productTypes[0]?.type || ""); // Default type
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [message, setMessage] = useState("");

  const handleQuantityChange = (productId, quantity, isDecimal) => {
    setSelectedProducts((prev) => ({
      ...prev,
      [productId]: { qty: Number(quantity), isDecimal }
    }));
  };

  const handleReset = () => {
    setSelectedProducts({});
    setPaymentMethods([]);
    setDiscount(0);
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const productsToSend = Object.entries(selectedProducts)
      .filter(([_, item]) => item.qty > 0)
      .map(([productId, { qty }]) => ({
        product_id: parseInt(productId),
        quantity: parseInt(qty),
      }));

    if (productsToSend.length === 0 || paymentMethods.length === 0) {
      setMessage("Debe seleccionar al menos un producto y un método de pago.");
      return;
    }

    const user = getUser();
    const saleData = {
      empresa_id: user?.empresa_id,
      products: productsToSend,
      payments: paymentMethods,
      discount,
    };

    try {
      const response = await fetch(`${URL}/api/sales/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Empresa-Id": user?.empresa_id,
        },
        body: JSON.stringify(saleData),
      });

      if (!response.ok) {
        setMessage("Error al crear la venta. Intente de nuevo.");
      } else {
        setMessage("Venta creada exitosamente.");
        handleReset();
        onClose();
      }
    } catch (error) {
      console.error("Error en la creación de venta:", error);
    }
  };

  return (
    <CreateSaleUI
      open={open}
      onClose={onClose}
      allProducts={allProducts}
      productTypes={productTypes}
      empresa={empresa}
      selectedProducts={selectedProducts}
      selectedType={selectedType}
      setSelectedType={setSelectedType}
      handleQuantityChange={handleQuantityChange}
      paymentMethods={paymentMethods}
      setPaymentMethods={setPaymentMethods}
      discount={discount}
      setDiscount={setDiscount}
      handleSubmit={handleSubmit}
      handleReset={handleReset}
      message={message}
    />
  );
}
